import { IMenuItem } from '../../../layout/navigation/models/nav-item.model';
import { AI_ASSISTANT_CLAIMS, EClaimsGroup } from '../claims.config';
import { AI_ASSISTANT_CONFIGURATION_ROUTES, AI_ASSISTANT_ROOT_ROUTES, ROOT_ROUTES } from '../router.config';

export const AI_ASSISTANT_NAVIGATION_CONFIG: IMenuItem[] = [
  {
    label: 'Configuration',
    expanded: true,
    claimGroupName: EClaimsGroup.aiAssistant,
    items: [
      {
        label: 'Knowledge Base',
        routerLink: `/${ROOT_ROUTES.aiAssistant}/${AI_ASSISTANT_ROOT_ROUTES.configuration}/${AI_ASSISTANT_CONFIGURATION_ROUTES.knowledgeBase}`,
        claimName: AI_ASSISTANT_CLAIMS.knowledgeBaseRead,
      },
      {
        label: 'Workflows',
        expanded: true,
        claimGroupName: EClaimsGroup.aiAssistant,
        items: [
          {
            label: 'Pricing & Availability Settings',
            routerLink: `/${ROOT_ROUTES.aiAssistant}/${AI_ASSISTANT_ROOT_ROUTES.configuration}/${AI_ASSISTANT_CONFIGURATION_ROUTES.pricingAndAvailability}`,
            claimName: AI_ASSISTANT_CLAIMS.priceAndAvailabilityRead,
          },
        ],
      },
    ],
  },
];
